<template>
  <div style="height: 100%">
    <div class="sa-flexbox" style="padding-bottom: 20px">
      <div class="sa-flexbox-body">
        <div class="d-flex flex-column">
          <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
            <b-col lg="3">
              <p>Records Totali: {{ rows }}</p>
            </b-col>
            <b-col lg="9">
              <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right"
                size="sm"></b-pagination>
            </b-col>
          </b-row>
        </div>
        <div class="b-table-sticky-header" v-show="initComponent">
          <transition name="animation" mode="out-in">
            <div v-if="items.length > 0" key="cards">
              <CardListComponent v-if="items.length > 0" ref="cmpCardListComponent" :items="items">
                <template v-slot:header="{ item }">
                  <div class="card-header-info-wrapper-horizontal">
                    <div class="card-header-info-item">
                      <div class="icon"><i class="fas fa-universal-access fa-2x text-muted"></i></div>
                      <div class="info-text">
                        <span>{{ item.accettazione.statoAttuale }}</span>
                      </div>
                    </div>
                    <div class="card-header-info-item">
                      <div class="icon"><i class="fas fa-id-card fa-2x text-muted"></i></div>
                      <div class="info-text">
                        <span>{{ item.accettazioneAnagrafica.identificativo }}</span>
                      </div>
                    </div>
                  </div>
                </template>
                <template v-slot:left="{ item }">
                  <img v-if="item.accettazioneAnagrafica.sesso === 'M'" src="@/assets/images/ico_m.png" />
                  <img v-else src="@/assets/images/ico_f.png" />
                </template>
                <template v-slot:right="{ item }">
                  <div class="card-right-info-wrapper">
                    <div class="card-right-info-item">
                      <div class="icon"><i class="fas fa-user fa-2x text-muted"></i></div>
                      <div class="info-text">
                        <strong>Nominativo</strong>
                        <span>{{ item.accettazioneAnagrafica.nome }} {{ item.accettazioneAnagrafica.cognome }}</span>
                      </div>
                    </div>
                    <div class="card-right-info-item">
                      <div class="icon"><i class="fas fa-user-clock fa-2x text-muted"></i></div>
                      <div class="info-text">
                        <strong>Data Accettazione</strong>
                        <span>{{ item.accettazione.dataAccettazione ?
                          formatDateTime(item.accettazione.dataAccettazione)
                          : "-" }}</span>
                      </div>
                    </div>
                    <div class="card-right-info-item">
                      <div class="icon"><i class="fas fa-calendar fa-2x text-muted"></i></div>
                      <div class="info-text">
                        <strong>Ultimo Appuntamento</strong>
                        <span>25/02/2026 12:30</span>
                      </div>
                    </div>
                    <div class="card-right-info-item">
                      <div class="icon"><i class="fas fa-users fa-2x text-muted"></i></div>
                      <div class="info-text">
                        <strong>Gruppo</strong>
                        <span>T</span>
                      </div>
                    </div>
                  </div>
                </template>
                <template v-slot:actions="{ item }">
                  <b-button v-b-tooltip.hover size="sm" variant="outline-info outline-secondary-noborder pull-right"
                    title="Scheda Paziente" @click="onClickSchedaPaziente(item)" class=" no-text">
                    <b-icon icon="eye" variant="outline-info"></b-icon>
                  </b-button>
                </template>
              </CardListComponent>
            </div>
            <NoDataComponent v-else ref="cmpNoDataComponent" title="Non sono presenti accettazioni" nome="no-data"
              subtitle="" icon="fas fa-users" />
          </transition>
        </div>
      </div>
      <div class="d-flex flex-column">
        <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
          <b-col lg="3">
            <p>Records Totali: {{ rows }}</p>
          </b-col>
          <b-col lg="9">
            <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right"
              size="sm"></b-pagination>
          </b-col>
        </b-row>
      </div>
      <b-modal ref="mdlScelta">
        <template></template>
      </b-modal>

      <pdf-print-view-embedded ref="pdfPrintViewEmbedded" :pdf="signedPdfViewer"></pdf-print-view-embedded>
    </div>
  </div>
</template>

<script>
import axios from "axios";
// import PrintComponent from "../../../utility/components/PdfPrintViewEmbedded.vue";
import UtilityMixin from "../../../utility/UtilityMixin";
import PdfPrintViewEmbedded from "../../../utility/components/PdfPrintViewEmbedded.vue";
//import PrintComponent from "../../../utility/components/PrintComponent.vue";
import NoDataComponent from "../../../../template/components/utility/NoDataComponent.vue";
import CardListComponent from "../../../../template/components/utility/CardListComponent.vue";
import moment from "moment";
export default {
  //PrintComponent
  mixins: [UtilityMixin],
  components: { PdfPrintViewEmbedded, NoDataComponent, CardListComponent },
  data() {
    return {
      initComponent: false,
      pathResource: "/accettazionessn",
      pathResourceRicette: "/accettazionericette",
      items: [],
      rows: 0,
      filtro: {
        codiceFiscaleAssistito: null,
        idPresidio: null,
      },
      page: 1,
      perPage: 1,
      signedPdfViewer: null,
      listKey: 0,
      previewSelected: null,
      currentPage: 1,
      rowSelectedAccettazione: {},
      listaRicetteDetails: {},

    };
  },

  mounted() {
    let me = this;
    me.init();

  },
  methods: {
    init() {
      let me = this;
      me.loadData();
    },
    getOra(date) {
      return moment(date).format("HH:mm");
    },
    getFormatDate(date) {
      return moment(date).format("DD/mm/yyyy");
    },
    onClickSchedaPaziente(item) {
      this.$router.push("/accettazionessn/schedapaziente/" + item.id)
    },

    loadData() {
      let me = this;
      me.$emit("beforeLoadData");
      me.items = [];
      let filtroStr = sessionStorage.getItem("filtroPageAccettazioneSsn");
      let filtroJson = JSON.parse(filtroStr);
      me.filtro = filtroJson;
      this.initComponent = true;
      if (me.filtro != null) {
        me.filtro.page = me.currentPage;
        me.filtro.forPage = me.perPage;
        if (me.filtro.idPresidio == null) {
          me.$emit("afterLoadData");
          me.$bvToast.toast("Selezionare Presidio!!", {
            title: "Azione Obbligatoria",
            variant: "warning",
            solid: true,
          });
          return;
        }
      }

      UtilityMixin.methods.loadDataResources(me.pathResource, me.filtro, me.loadDataAccettazioneSsnSuccess, me.loadDataAccettazioneSsnError);
    },

    loadDataAccettazioneSsnSuccess(response) {
      let me = this;
      me.items = response.data.data.list;
      me.rows = response.data.data.recordsNumber;
      me.listKey++;
      me.$emit("afterLoadData");

    },
    loadDataAccettazioneSsnError(response) {
      let me = this;
      me.$emit("afterLoadData", response);
      console.log(response);

      me.$bvToast.toast(response.response.data.messaggio, {
        title: "Errore",
        variant: "danger",
        solid: true,
      });

    },
    getColorBackGround(prestazione) {
      let color = "#b6b5b5";
      color = prestazione.appuntamenti.length == prestazione.quantita ? "#00a3ff" : "#ffc107";
      return color;
    },
    linkPrintData(item) {
      let returnValue = "/printer/" + item.id;
      return returnValue;
    },
    onClickOpenDetailAccettazione(accettazione) {
      this.$router.push("accettazionessn/" + accettazione.id);
    },
    onClickDettaglio(row) {
      if (this.listaRicetteDetails[row.item.id]) {
        row.toggleDetails();
      } else {
        this.loadRicetteByAccettazione(row);
      }
    },
    loadRicetteByAccettazione(row) {
      let link = process.env.VUE_APP_PATH_API + this.pathResourceRicette;
      axios
        .get(link, { params: { idAccettazione: row.item.id } })
        .then((response) => {
          this.listaRicetteDetails[row.item.id] = response.data.data.list;
          row.toggleDetails();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    onClickAnteprimaStampa(item) {
      let me = this;
      let prestazioni = null;
      let identificativo = item.accettazione.accettazioneAnagrafica.identificativo;
      if (item.ricette.length >= 1) {
        prestazioni = item.ricette[0].prestazioni;
      } else {
        //TODO
      }
      let print = {
        reportName: "RegistroPresenze",
        data: {
          identificativo: identificativo,
          prestazioni: prestazioni,
        },
      };
      me.onPrintPreview(print);
    },
    onClickAnnulla() {
      let me = this;
      me.$refs.mdlPreviewStampa.hide();
    },
    onPrintPreview(item) {
      let me = this;
      let link = process.env.VUE_APP_PATH_API + "/print/createreport";
      me.showModalLoading = true;
      axios
        .post(link, item)
        .then((response) => {
          me.signedPdfViewer = "data:application/pdf;base64," + response.data.base64;

          me.$refs.pdfPrintViewEmbedded.show();
        })
        .catch((error) => {
          // me.$refs.mdlGenerazioneReportInCorso.hide();
          me.showModalLoading = false;
          let messaggio = error.response.data.messaggio ? error.response.data.messaggio : "Errore non gestito, Codice: " + error.response.status;
          this.$bvModal
            .msgBoxOk(messaggio, {
              title: this.$i18n.t("ERROR!"),
              size: "sm",
              okVariant: "outline-danger",
              headerClass: "sa-msg-header-danger",
              footerClass: "p-2 border-top-0",
              centered: true,
            })
            .then((value) => {
              this.boxTwo = value;
            })
            .catch((err) => {
              err;
            });
        });
    },
  },
  watch: {
    currentPage() {
      let me = this;
      me.loadData();
    },
  },
};
</script>

<style scoped>
.ft-wrapper-ricetta {
  margin-bottom: 16px;
}

.ft-ricetta-titolo {
  font-weight: 600;
  display: block;
  margin-bottom: 8px;
}

/* Prestazioni orizzontali */
.ft-wrapper-prestazioni {
  display: flex;
  gap: 16px;
}

.ft-prestazione-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 8px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background: #f9f9f9;
}

.ft-prestazione-codice {
  font-weight: 600;
  margin-bottom: 6px;
}

.ft-prestazione-badge-container {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
}

.ft-badge {
  min-width: 22px;
  height: 22px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  color: white;
  font-weight: 600;
}

.ft-badge-complete {
  background-color: #00a3ff;
}

.ft-badge-incomplete {
  background-color: #ffc107;
}

.ft-badge-total {
  background-color: #00a3ff;
}

.sa-badge-internal {
  border-radius: 5px;
  border-left: 4px solid var(--bg-sidebar-item);
  border-top: 1px solid var(--bg-main-nav-bar);
  border-bottom: 1px solid var(--bg-main-nav-bar);
  border-right: 1px solid var(--bg-main-nav-bar);
  padding: 7px !important;
  margin-bottom: 5px;
  max-width: max-content;
}

.sa-badge {
  width: 100%;
  max-width: none !important;

}

.card-right-info-wrapper {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  font-family: Arial, sans-serif;
}

.card-right-info-item {
  display: flex;
  align-items: center;
  background: #f9f9f9;
  padding: 1rem;
  border-radius: 12px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  min-width: 90%;
  transition: transform 0.2s;
}

.card-right-info-item:hover {
  transform: translateY(-2px);
}

.icon i {
  font-size: 1.8rem;
  margin-right: 1rem;

}

.info-text strong {
  display: block;
  font-weight: 600;
  margin-left: 5px;
  color: #333;
}

.info-text span {
  font-size: 0.95rem;
  margin-left: 5px;
  color: #555;
}

.card-header-info-wrapper-horizontal {
  display: flex;
  margin-top: 5px;
  width: 100%;
}

.card-header-info-item {
  display: flex;
  align-items: center;
  justify-items: center;
  gap: 4px;
  flex: 1;
  padding: 4px;
  justify-content: center;
}

.card-header-info-item .info-text span {
  font-size: 0.95em;
  color: #333;
}


.animation-enter-active,
.animation-leave-active {
  transition: opacity 0.8s ease, transform 0.8s ease;
}

.animation-enter-from {
  opacity: 0;
  transform: translateY(20px);
}

.animation-enter-to {
  opacity: 1;
  transform: translateY(0px);
}

.animation-leave-from {
  opacity: 1;
  transform: translateY(0px);
}

.animation-leave-to {
  opacity: 0;
  transform: translateY(20px);
}
</style>
